export const useIsNativeApp = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const isNativeApp = navigator.userAgent === 'capturex-native-app';

  return isNativeApp;
};
